import React from 'react';
import {
  LISTING_ATTRIBUTE_SECTIONS,
  mergeListingAttributes
} from '../config/listingAttributesModel';

const btnBase =
  'px-3 py-1.5 rounded-full border text-[13px] transition-colors';
const btnOff = 'bg-[#fafafa] border-[#e5e3df] text-[#78736A]';
const btnOn = 'bg-[#FF5E4C]/10 border-[#FF5E4C] text-[#FF5E4C] font-medium';

function setVal(attrs, key, value) {
  return { ...attrs, [key]: value };
}

/**
 * Full lifestyle / amenities form for admin + vendor stay create/edit.
 */
const ListingAttributesEditor = ({ value, onChange }) => {
  const attrs = mergeListingAttributes(value);

  const patch = (key, v) => onChange(setVal(attrs, key, v));

  const toggleMulti = (key, opt) => {
    const cur = Array.isArray(attrs[key]) ? [...attrs[key]] : [];
    const next = cur.includes(opt) ? cur.filter((x) => x !== opt) : [...cur, opt];
    patch(key, next);
  };

  return (
    <div className="space-y-8">
      {LISTING_ATTRIBUTE_SECTIONS.map((section) => (
        <div
          key={section.id}
          className="bg-white rounded-[16px] shadow-[0_4px_4px_rgba(0,0,0,0.04)] border border-[#E5E3DF] p-5 md:p-6"
        >
          <h3 className="text-[16px] font-medium text-black mb-4">{section.title}</h3>
          <div className="space-y-4">
            {section.fields.map((field) => (
              <div key={field.key} className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-6">
                <label className="text-[13px] font-regular text-[#5c5c5c] sm:w-[240px] shrink-0 pt-1.5">
                  {field.label}
                </label>
                <div className="flex-1 min-w-0">
                  {field.type === 'yesno' && (
                    <div className="flex flex-wrap gap-[4px]">
                      <button
                        type="button"
                        className={`${btnBase} ${attrs[field.key] == null ? btnOn : btnOff}`}
                        onClick={() => patch(field.key, null)}
                      >
                        —
                      </button>
                      <button
                        type="button"
                        className={`${btnBase} ${attrs[field.key] === 'Yes' ? btnOn : btnOff}`}
                        onClick={() => patch(field.key, 'Yes')}
                      >
                        Yes
                      </button>
                      <button
                        type="button"
                        className={`${btnBase} ${attrs[field.key] === 'No' ? btnOn : btnOff}`}
                        onClick={() => patch(field.key, 'No')}
                      >
                        No
                      </button>
                    </div>
                  )}
                  {field.type === 'select' && (
                    <select
                      value={attrs[field.key] ?? ''}
                      onChange={(e) =>
                        patch(field.key, e.target.value === '' ? null : e.target.value)
                      }
                      className="w-full max-w-md px-3 py-2 border border-[#E5E3DF] rounded-[12px] text-[14px] bg-white"
                    >
                      <option value="">Not specified</option>
                      {field.options.map((o) => (
                        <option key={o} value={o}>
                          {o}
                        </option>
                      ))}
                    </select>
                  )}
                  {field.type === 'multiselect' && (
                    <div className="flex flex-wrap gap-[4px]">
                      {field.options.map((o) => {
                        const sel = (attrs[field.key] || []).includes(o);
                        return (
                          <button
                            key={o}
                            type="button"
                            className={`${btnBase} ${sel ? btnOn : btnOff}`}
                            onClick={() => toggleMulti(field.key, o)}
                          >
                            {o}
                          </button>
                        );
                      })}
                    </div>
                  )}
                  {field.type === 'number' && (
                    <input
                      type="number"
                      min={field.min}
                      max={field.max}
                      value={attrs[field.key] ?? ''}
                      onChange={(e) => {
                        const v = e.target.value;
                        patch(field.key, v === '' ? null : parseFloat(v, 10));
                      }}
                      className="w-full max-w-[200px] px-3 py-2 border border-[#E5E3DF] rounded-[12px] text-[14px]"
                      placeholder="—"
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ListingAttributesEditor;
